import { render, staticRenderFns } from "./CreateChapter.vue?vue&type=template&id=36105d7e&scoped=true&"
import script from "./CreateChapter.vue?vue&type=script&lang=js&"
export * from "./CreateChapter.vue?vue&type=script&lang=js&"
import style0 from "./CreateChapter.vue?vue&type=style&index=0&id=36105d7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36105d7e",
  null
  
)

export default component.exports